import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { selectionLabelClass } from '~/components/ui/selectionCheckbox';
import type { NegotiationCellState } from './negotiationCellState';

const CELL_FILLED_BY_LABEL_CLASS = 'h-px p-0';

function labelFillingCellClass(isDisabled: boolean) {
  return `h-full px-6 py-4 ${selectionLabelClass(isDisabled, 'flex')}`;
}

export function NegotiationCheckboxCell({
  state,
  sellerName,
}: Readonly<{ state: NegotiationCellState; sellerName: string }>) {
  const { t } = useTranslation('order-builder');

  return (
    <td className={CELL_FILLED_BY_LABEL_CLASS}>
      <label
        title={state.tooltip}
        className={labelFillingCellClass(state.isDisabled)}
      >
        <input
          id={state.checkboxId}
          type="checkbox"
          aria-label={t(
            'order_builder.table.negotiate_price_seller_aria_label',
            { sellerName }
          )}
          checked={state.isSelected}
          disabled={state.isDisabled}
          title={state.tooltip}
          onChange={state.onToggle}
        />
      </label>
    </td>
  );
}

export function NegotiationSellerCell({
  state,
  children,
}: Readonly<{ state: NegotiationCellState; children: ReactNode }>) {
  return (
    <td className={`${CELL_FILLED_BY_LABEL_CLASS} whitespace-nowrap`}>
      <label
        htmlFor={state.checkboxId}
        title={state.tooltip}
        className={labelFillingCellClass(state.isDisabled)}
      >
        {children}
      </label>
    </td>
  );
}
